import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=3182f937&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=3182f937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182f937",
  null
  
)

export default component.exports